<template>
	<div class="generic-select" :class="[{'blurred' : isDisabled}, {'background-light' : $route?.meta?.backgroundColor === 'light'}]">
		<div class="label-holder">
			<label :for="field" v-html="label"></label>
			<CommonHint v-if="hint">
				<template v-slot:hint>
					<slot name="hint">

					</slot>
				</template>
			</CommonHint>
		</div>
		<div class="dropdown-container" :id="field + number">
			<div class="options-container">
				<div class="dropdown-activator" @click="openDropdown">
					<input
						class="inline-search"
						type="text"
						:placeholder="placeholder"
						autocomplete="off"
						v-model="keyWord"
					>
					<span class="arrow" ref="dropArrow">
					<img src="@/drc/assets/icons/triangle-down.svg" alt="Dropdwon">
				</span>
				</div>
				<div class="selected-options" v-if="notValidatedOptions?.length > 0 || selectedOptions?.length > 0">
					<span v-for="(selectedOption, index) in selectedOptions" :key="field + 'selected' + index"
								:class="[
									`selected-tag`,
									{'for-approval' : selectedOption?.approvalStatus === 'FOR_APPROVAL'}, {'inactive' : selectedOption?.approvalStatus === 'INACTIVE'}]"
								v-if="options.find(el => id ? (el[id] === selectedOption?.[id]) : (el[textFieldName] === selectedOption?.[textFieldName]))">
						<template>
							<img
								v-if="imageUrl"
								class="icon"
								:src="require(`@/${imageUrl}${selectedOption?.[imageFieldName ? imageFieldName : textFieldName]}.svg`)"
							>
							<span class="option-name" @click="redirectForApproval(selectedOption)">{{options.find(el => id ? (el[id] === selectedOption?.[id]) : (el[textFieldName] === selectedOption?.[textFieldName]))[textFieldName]}}</span>
							<img
								src="@/drc/assets/icons/x_black.svg"
								alt="Remove"
								@click="selectOption(selectedOption)">
							</template>
					</span>

					<span v-if="notValidatedOptions?.length" v-for="(selectedOption, index) in notValidatedOptions" :key="field + 'notValidated' + index"
								:class="[
									`selected-tag`,
									`not-validated`,
									{'for-approval' : selectedOption?.approvalStatus === 'FOR_APPROVAL'},
									{'inactive' : selectedOption?.approvalStatus === 'INACTIVE'}
								]">
						<template>
							<img
								v-if="imageUrl"
								class="icon"
								:src="require(`@/${imageUrl}${selectedOption?.[imageFieldName ? imageFieldName : textFieldName]}.svg`)"
								alt="x"
							>
							<span class="option-name">{{selectedOption?.[textFieldName]}}</span>
							<img
								src="@/drc/assets/icons/x_black.svg"
								alt="Remove"
								@click="removeNotValidatedOption(selectedOption)">
							</template>
					</span>

				</div>
				<div class="dropdown-options" ref="optionContainer">
					<div class="option" :class="disabledIdList.indexOf(option[id]) !== -1 ? 'unavalable' : ''" v-for="(option, index) in filteredOptions"
							 :key="index" @click="selectOption(option)">
						<span class="option-checkmark">
							<img
								src="@/drc/assets/images/check-dark.png"
								v-show="selectedOptions?.find(el => id ? (el?.[id] === option?.[id]) : (el?.[textFieldName] === option?.[textFieldName]))"
								alt="Check">
						</span>
						<img
							v-if="imageUrl"
							class="icon"
							:src="require(`@/${imageUrl}${option?.[imageFieldName ? imageFieldName : textFieldName]}.svg`)"
						>
						<span class="option-text">{{ option?.[textFieldName] }}</span>
					</div>
					<div class="option" v-if="canAddNew && keyWord.trim()" @click="addNewOption">
						<span class="option-checkmark">
							<img src="@/drc/assets/images/check.png" alt="Check">
						</span>
						<span class="option-text">Add new</span>
					</div>
					<div class="option disabled" v-else-if="!filteredOptions?.length">
						<span class="option-checkmark">
							<img src="@/drc/assets/images/check-dark.png" alt="Check">
						</span>
						<span class="option-text">{{$t(errorLabel)}}</span>
					</div>
					<div v-if="notValidatedOptions?.length" class="not-validated-text-container">
					</div>
				</div>
				<span v-for="(selectedOption, index) in notValidatedOptions" :key="field + 'selectedNotValidated' +index">
					{{selectedOption?.[textFieldName]}} is not validated <br/>
				</span>
			</div>


		</div>
		<div class="errors" v-if="typeof number !== 'number' && formData[field].errors?.length > 0 && !isDisabled">
				<span v-for="(error, index) in formData[field].errors" :key="index">
					{{ $t(`${error}`)+'.' }}
				</span>
		</div>
	</div>
</template>

<script>
import CommonHint from "@/drc/pages/submit-form/components/CommonHint.vue";
import {validateField} from "@/drc/pages/submit-form/submission-service";
import {PERMISSIONS} from "@/common/utils/constants";

export default {
	name: "CommonSelect",
	components: {CommonHint},
	data() {
		return {
			selectedOptions: [],
			errors: [],
			keyWord: "",
			regex: new RegExp(""),
			notValidatedOptions: [],
		}
	},
	props: {
		errorLabel:{
			type: String,
			required: false,
			default: 'No options available'
		},
		imageUrl: {
			type: String,
			required: false
		},
		imageFieldName: {
			type: String,
			required: false
		},
		placeholder: {
			type: String,
			required: true
		},
		formData: {
			type: Object,
			required: true
		},
		options: {
			type: Array,
			required: true
		},
		hint: {
			type: Boolean,
			required: false
		},
		label: {
			type: String,
			required: false
		},
		field: {
			type: String,
			required: true
		},
		textFieldName: {
			type: String,
			required: true
		},
		isMultiple: {
			type: Boolean,
			required: false,
			default: true
		},
		id: {
			type: String,
			required: false
		},
		canAddNew: {
			type: Boolean,
			required: false,
			default: false
		},
		number: {
			type: Number,
			required: false
		},
		isDisabled: {
			type: Boolean,
			required: false,
			default: false
		},
		disabledIdList: {
			type: Array,
			required: false,
			default: () => []
		},
	},
	methods: {
		deleteAttributeEvent(event) {
			if (event.key === 'deleteAttribute' && event.newValue) {
				let deletedAttribute = JSON.parse(event.newValue);
				this.removeNotValidatedOption(deletedAttribute);
			}
		},
		updateAttributeEvent(event) {
			if (event.key === 'updateAttribute' && event.newValue) {
				let updatedAttribute = JSON.parse(event.newValue);

				this.selectedOptions?.forEach(item => {
					if (item.id === Number(updatedAttribute.id)) {
						let obj = {...item}
						obj.name = updatedAttribute.name;
						obj.gopApprovalStatus = updatedAttribute.status
						obj.approvalStatus = updatedAttribute.status
						localStorage.removeItem('updateAttribute');
						this.replaceAttribute(item, obj);
						return;
					}
				})
			}
		},
		replaceAttribute(item, object) {
			const index = this.selectedOptions.findIndex(option => option === item);

			if (index !== -1) {
				const newSelectedOptions = [...this.selectedOptions];
				newSelectedOptions.splice(index, 1, object);
				this.$set(this.formData[this.field], 'value', newSelectedOptions);
			}
		},
		redirectForApproval(selectedOption) {

			if (selectedOption.approvalStatus && selectedOption.approvalStatus === "FOR_APPROVAL") {
				const url = this.$router.resolve({path: '/control-panel/manage-labels', query: { text: selectedOption.name }}).href;
				window.open(url, '_blank');
			}
		},
		addNewOption() {
			if (!this.isMultiple) {
				this.selectedOptions = [];
				this.notValidatedOptions = [];
			}

			const obj = {[this.textFieldName]: this.keyWord, [this.id]: null};
			if ((this.label.includes('Tools') || this.label.includes('Certifications')) && (this.$store.getters.getUser?.permissions?.includes(PERMISSIONS.additionalAdminAccess)
				|| this.$store.getters.getUser?.permissions?.includes(PERMISSIONS.additionalCmtAccess))) {
				obj.gopApprovalStatus = "APPROVED"
				obj.approvalStatus = "APPROVED"
			}

			if (this.label.includes('Tools')) {
				obj.type = 'TOOL'
			}

			if (this.label.includes('Certifications')) {
				obj.type = 'CERTIFICATION'
			}

			this.selectedOptions.push(obj);
			if(this.notValidatedOptions.find(el => el[this.textFieldName] === obj[this.textFieldName]) === undefined){
				this.notValidatedOptions.push(obj);
			}

			this.$set(this.formData[this.field], 'value', this.selectedOptions);
			this.validate(false);

			this.closeDropdown();
			this.keyWord = "";
		},
		removeNotValidatedOption(selected) {
			this.notValidatedOptions = this.notValidatedOptions.filter(el => el[this.textFieldName] !== selected[this.textFieldName]);
			this.selectedOptions = this.selectedOptions.filter(el => el[this.textFieldName] !== selected[this.textFieldName]);

			this.$set(this.formData[this.field], 'value', this.selectedOptions);
			this.validate(false);
		},
		selectOption(selected) {
			if(this.disabledIdList.indexOf(selected[this.id]) !== -1){
				return;
			}

			let selectOption = this.options?.find((option) => this.id ? option[this.id] === selected[this.id] : option[this.textFieldName] === selected[this.textFieldName]);
			let isSelected = !!this.selectedOptions?.find((option) => this.id ? option[this.id] === selected[this.id] : option[this.textFieldName] === selected[this.textFieldName]);

			if (!this.isMultiple) {
				this.formData[this.field].value = [];
				this.selectedOptions = [];
				this.notValidatedOptions = [];
				this.closeDropdown();
				this.keyWord = "";
			}

			if (!isSelected) {
				this.selectedOptions = !this.selectedOptions ? [] : this.selectedOptions
				this.selectedOptions.push(selectOption);
			} else {
				this.selectedOptions = this.selectedOptions.filter(el => this.id ? (el[this.id] !== selectOption[this.id]) : (el[this.textFieldName] !== selectOption[this.textFieldName]));
			}
			if(typeof this.number === "number"){
				if(this.selectedOptions.length === 0) {
					this.$set(this.formData[this.field].value, this.number, undefined);
				}else{
					this.$set(this.formData[this.field].value, this.number, this.selectedOptions);
				}
			}else{
				this.$set(this.formData[this.field], 'value', this.selectedOptions);
				this.keyWord = '';
			}
			this.$emit('selectedOption', selectOption);
			this.validate(false);
		},
		checkClickEvent(event) {
			if (!event.target.closest('.dropdown-container#' + this.field + this.number)) {
				if (this.$refs.optionContainer.style?.maxHeight != '0px') {
					this.closeDropdown();
				}
			}
		},
		closeDropdown() {
			this.$refs.optionContainer.style.maxHeight = "0";
			this.$refs.dropArrow.classList.remove('active');
		},
		openDropdown() {
			if (!this.$refs.dropArrow.classList.contains('active')) {
				this.$refs.optionContainer.style.maxHeight = "200px";
				this.$refs.dropArrow.classList.add('active');
			}
		},
		validate() {
			validateField(this.formData, this.field);
		},
	},
	watch: {
		options: {
			handler: function (val) {
				this.notValidatedOptions = [];
			},
			deep: true
		},
		keyWord(newValue) {
			this.regex = new RegExp(newValue, "gi");
		},
		formData: {
			handler: function (val) {
				if(typeof this.number === "number"){
					this.selectedOptions = val[this.field].value[this.number]
					// if(this.isMultiple){
					// 	this.notValidatedOptions = val[this.field].value[this.number]?.filter(option => !this.options.find(el => this.id ? el[this.id] === option[this.id] : el[this.textFieldName] === option[this.textFieldName])) || []
					// }
				}else{
					this.selectedOptions = val[this.field].value
					if(this.isMultiple){
						this.notValidatedOptions = val[this.field].value?.filter(option => !this.options.find(el => this.id ? el[this.id] === option[this.id] : el[this.textFieldName] === option[this.textFieldName])) || [];
					}
				}
			},
			deep: true
		}
	},
	mounted() {
		document.addEventListener("click", this.checkClickEvent);
		if(typeof this.number === "number"){
			this.selectedOptions = this.formData[this.field].value[this.number]
		}else{
			this.selectedOptions = this.formData[this.field].value
		}
		window.addEventListener('storage', this.updateAttributeEvent);
		window.addEventListener('storage', this.deleteAttributeEvent);
	},
	beforeDestroy() {
		document.removeEventListener("click", this.checkClickEvent);
		window.removeEventListener('storage', this.updateAttributeEvent);
		window.removeEventListener('storage', this.deleteAttributeEvent);
	},
	computed: {
		filteredOptions() {
			const vue = this;
			return (this.options?.filter) ? this.options.filter((option) => {
				return option[vue.textFieldName].match(vue.regex);
			}) : [];
		}
	},
}
</script>


<style scoped lang="scss">
@import "@/common/assets/css/_variables.scss";

.generic-select {
	width: 100%;

	.label-holder {
		label {
			font-family: Roboto, serif;
			font-weight: 600;
			font-size: 17px;
			line-height: 22px;
			letter-spacing: 0;
		}
	}

	&.blurred {
		.dropdown-container {
			pointer-events: none;
			opacity: 0.5;
		}
	}

	.dropdown-container {
		.options-container {
			.selected-options {
				margin-top: 5px;
				max-height: none !important;

				.icon {
					height: 1rem;
					max-height: none;
					margin-top: -1px;
					cursor: default;

					&:hover{
						transform: scale(1);
					}
				}

				.selected-tag {
					background: #FFB81C;
					padding: 10px;

					.option-name {
						color: black;
						font-weight: 500;
						position: relative;
						top: 1px;
					}

					.icon {
						margin-right: 5px;
					}
				}

				.not-validated {
					background: white;
				}

				.for-approval {
					background: transparent;
					border: 1px solid #FFB81C;
					position: relative;
					cursor: pointer;

					.option-name {
						color: white;
					}

					img {
						filter: brightness(0) saturate(100%) invert(100%) sepia(19%) saturate(2%) hue-rotate(53deg) brightness(102%) contrast(101%);
					}

					&:after {
						position: absolute;
						bottom: 135%;
						left: 0;
						width: fit-content;
						background: #35404B;
						color: white;
						content: "FOR APPROVAL";
						font-size: 11px;
						padding: 5px;
						border-radius: 4px;
						display: none;
					}

					&:before {
						content: "";
						position: absolute;
						border-left: 10px solid transparent;
						border-right: 10px solid transparent;
						border-bottom: 10px solid #35404B;
						bottom: 117%;
						left: 30%;
						transform: rotate(-180deg);
						display: none;
					}

					&:hover {
						&:before, &:after {
							display: block;
						}
					}
				}

				.inactive {
					background: transparent;
					border: 1px solid #ae0fef;
					color: white;
					position: relative;

					img {
						filter: brightness(0) saturate(100%) invert(100%) sepia(19%) saturate(2%) hue-rotate(53deg) brightness(102%) contrast(101%);
					}

					&:after {
						position: absolute;
						bottom: 135%;
						left: 0;
						width: fit-content;
						background: #35404B;
						color: white;
						content: "INACTIVE";
						font-size: 11px;
						padding: 5px;
						border-radius: 4px;
						display: none;
					}

					&:before {
						content: "";
						position: absolute;
						border-left: 10px solid transparent;
						border-right: 10px solid transparent;
						border-bottom: 10px solid #35404B;
						bottom: 117%;
						left: 25.5%;
						transform: rotate(-180deg);
						display: none;
					}

					&:hover {
						&:before, &:after {
							display: block;
						}
					}
				}
			}

			.not-validated-text-container {
				display: flex;
				flex-direction: column;
			}

			.dropdown-options {
				scrollbar-color: $newsletter-hover-background $light-grey;
				background: $color-white;
				box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
				top: 35px;
				scrollbar-color: #D99C15 transparent;
				scrollbar-width: thin;
				margin-top: -1px;
				margin-left: 1px;
				width: calc(100% - 2px);
				border-radius: 0;

				.option {
					display: flex;
					color: $newsletter-hover-background;
					opacity: 1;

					&.unavalable {
						opacity: 0.2;
						background: #ffffff !important;
					}

					.option-text {
						min-height: 20px;
					}

					&:hover .option-text {
						color: $newsletter-hover-background;
						opacity: 0.5;
					}

					.icon {
						height: 1rem;
						margin-left: 2rem;
					}

					.option-checkmark {
						border-color: $newsletter-hover-background;
					}

					&:nth-child(odd) {
						background: $color-white-light;
					}

					&:nth-child(even) {
						background: $color-white-dark3;
					}
				}
			}
		}

		.dropdown-activator {
			background-color: $color-white-light;
			min-height: 44px;
			padding-left: 12px;
			padding-right: 12px;
			border-radius: 0;

			.inline-search {
				flex-basis: 95%;
				color: $newsletter-hover-background;
				border: none;
				outline: none;
				font-family: Roboto, serif;
				font-weight: 400;
				font-size: 16px;
				line-height: 21px;
				letter-spacing: 0;
				overflow: hidden;
				text-overflow: ellipsis;
				-webkit-line-clamp: 1;

				&::placeholder {
					color: $newsletter-hover-background;
					opacity: 1;
				}

				&:-ms-input-placeholder {
					color: $newsletter-hover-background;
					font-style: italic
				}

				&::-ms-input-placeholder {
					color: $newsletter-hover-background;
					font-style: italic
				}
			}
		}
	}

	select.input-error {
		border: 1px solid #FF453A;
	}

	label {
		font-family: "Roboto", sans-serif;
		color: #FCFCFE;
		font-size: 14px;
		font-weight: 500;
		flex-basis: 20%;
	}

	.errors {
		display: flex;
		margin-bottom: 10px;

		span {
			color: #FF453A;
			margin: 0;
			font-size: 14px;
			font-weight: 500;
			font-family: "Roboto", sans-serif;
			max-height: 15px;
		}
	}
}


.background-light {
	.dropdown-container {
		.options-container > .dropdown-activator {
			border: 1px solid #E5E5EA;
		}
	}

	.label-holder {
		label {
			color: #001F33;
		}
	}
}
</style>
